import React, { useCallback, useState } from 'react'

import { HiOutlineTag } from 'react-icons/hi'
import { twMerge } from 'tailwind-merge'

import {
  type BreadcrumbItem,
  FullBreadcrumbList,
} from '@/components/common/Breadcrumb'
import Button from '@/components/common/Button'
import { OrgPermissionGate } from '@/components/common/PermissionGate'
import IntercomButton from '@/components/layouts/common/Navbar/Intercom'
import { EditTagsDialog } from '@/components/tags/EditTagsDialog'

import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

interface NavbarProps {
  breadcrumbs: BreadcrumbItem[]
  className?: string
}

export const Navbar: React.FC<NavbarProps> = ({ breadcrumbs, className }) => {
  const { activeOrgId } = useActiveOrgId()

  const [isEditTagsDialogOpen, setIsEditTagsDialogOpen] = useState(false)

  // The breadcrumb trail's back-arrow parent crumb replaces the old
  // history-back icon button.

  const handleManageTags = useCallback(() => {
    setIsEditTagsDialogOpen(true)
  }, [setIsEditTagsDialogOpen])

  return (
    <div
      className={twMerge(
        'flex items-center justify-between h-full px-3 min-h-[48px] h-[48px] max-h-[48px] gap-3',
        className,
      )}
    >
      <EditTagsDialog
        open={isEditTagsDialogOpen}
        setOpen={setIsEditTagsDialogOpen}
        tagType="organization"
      />
      <div className="flex min-w-0 items-center gap-3 flex-1">
        <div className="min-w-0 flex-1 overflow-hidden">
          <FullBreadcrumbList
            items={breadcrumbs}
            hrefPrefix={activeOrgId ? `/orgs/${activeOrgId}/library/` : ''}
          />
        </div>
      </div>
      <div className="shrink-0 flex items-center gap-x-3">
        <OrgPermissionGate permission="write" fallback="hide">
          <Button
            variant="outline-compact"
            className="flex items-center shadow-sm"
            onClick={handleManageTags}
          >
            <HiOutlineTag
              size={16}
              className="text-primary-700 dark:text-primary-300"
            />
            <span className="text-sm font-medium">Manage Tags</span>
          </Button>
        </OrgPermissionGate>
        <IntercomButton />
      </div>
    </div>
  )
}
